/**
 * Parses a multi-enum custom field value into a deduplicated list of strings.
 * Canonical storage format is a comma-separated string; arrays are accepted for legacy data.
 */
export function parseMultiEnumValue(value) {
  if (value === undefined || value === null || value === '') {
    return [];
  }

  if (Array.isArray(value)) {
    return [...new Set(value.map((item) => String(item).trim()).filter(Boolean))];
  }

  if (typeof value === 'string') {
    return [...new Set(value.split(',').map((item) => item.trim()).filter(Boolean))];
  }

  return [];
}

/**
 * Serializes multi-enum values to the canonical comma-separated string.
 */
export function formatMultiEnumValue(values) {
  return parseMultiEnumValue(values).join(',');
}

/**
 * Attaches or detaches a single option in a multi-enum field.
 */
export function mergeMultiEnumValue(existingValue, incomingValue, isAttach) {
  const currentValues = parseMultiEnumValue(existingValue);
  const incoming = String(incomingValue).trim();

  if (!incoming) {
    return formatMultiEnumValue(currentValues);
  }

  if (isAttach) {
    if (currentValues.includes(incoming)) {
      return formatMultiEnumValue(currentValues);
    }
    return formatMultiEnumValue([...currentValues, incoming]);
  }

  return formatMultiEnumValue(currentValues.filter((item) => item !== incoming));
}
